import About from './components/About';
import Home from './components/Home';
import Projects from './components/Projects';
import Footer from './components/Footer';
import './style.css';
import Header from './components/Header';



function App() {
  return (
    <>
    <Header/>
    < Home/>
    < About/>
    <Projects/>
    <Footer/>
    </>
  );
}

export default App;
